import type { ApiHelper, ApiResponseWithData, BaseRequest } from '..';
import { ApiHelperWithData, splitParams } from '..';
import type { MpMgmtSearchParams, MpMgmtSearchResponse } from '../model';

export class MpMgmtApi {
  private withData: ApiHelperWithData;

  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  search = (
    params: MpMgmtSearchParams & BaseRequest,
  ): Promise<ApiResponseWithData<MpMgmtSearchResponse>> => {
    const url = '/apis/mp-mgmt/search';
    return this.withData.postJson(url, ...splitParams(params));
  };
}
